module.exports = __webpack_public_path__ + "img/scope-delivery.cf361a8e.png";